import React, { Component } from "react";
import { message, Space, Tag, Tooltip, Upload, Alert, Popconfirm, Row, Col } from "antd";
import { PlusOutlined, EditOutlined, StopOutlined, CheckCircleOutlined, DeleteOutlined, DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import { ButtonItem, TableItem, ModalItem, InputItem, MensajeError } from "../../../../Components/Items";
import { descargarPlantillaCodigos, filasCodigosDesdeHoja } from "./plantillaCodigosTiempoMuerto";

const codigoVacio = { _id: null, origen: "", motivo: "", codigo: "", estado: 1 };

class CodigosTiempoMuertoPU extends Component {
  state = { loading: false, codigos: [], editando: null, resultado: null };

  componentDidMount() {
    this.cargar();
  }

  post = (ruta, datos) => axios.post(`tiemposMuertosPU/${ruta}`, { empresaId: this.props.empresaId, ...datos }, { headers: this.props.headersToken });

  cargar = () => {
    this.setState({ loading: true });
    return this.post("listarCodigos", {})
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) this.setState({ codigos: res.data.codigos || [] });
        else MensajeError({ message: res.data.error || "Error al cargar los códigos" });
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  guardar = (codigo) => {
    this.setState({ loading: true });
    this.post("guardarCodigo", { codigoId: codigo._id || undefined, origen: codigo.origen, motivo: codigo.motivo, codigo: codigo.codigo, estado: codigo.estado })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Código guardado");
          this.setState({ editando: null });
          this.cargar();
        } else {
          MensajeError({ message: res.data.error || "No se pudo guardar el código" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  eliminar = (codigo) => {
    this.post("eliminarCodigo", { codigoId: codigo._id })
      .then((res) => {
        if (res.data.success === 2) {
          message.success(res.data.desactivado ? "El código ya se usó en paros; se desactivó en lugar de eliminarse" : "Código eliminado");
          this.cargar();
        } else {
          MensajeError({ message: res.data.error || "No se pudo eliminar el código" });
        }
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  };

  onSubirArchivo = ({ file }) => {
    if (!/\.xlsx?$/i.test(file.name || "")) {
      message.error("El archivo debe ser un Excel (.xlsx/.xls)");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = (e) => {
      let filas;
      try {
        const libro = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
        filas = filasCodigosDesdeHoja(XLSX, libro.Sheets[libro.SheetNames[0]]);
      } catch (error) {
        message.error("No se pudo leer el archivo. Verifica que sea un Excel válido.");
        return;
      }
      if (!filas) {
        message.error("No se encontraron las columnas Origen, Motivo y Código en el archivo.");
        return;
      }
      if (filas.length === 0) {
        message.error("El archivo no tiene renglones con códigos.");
        return;
      }
      this.setState({ loading: true });
      this.post("importarCodigos", { filas })
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            this.setState({ resultado: res.data });
            this.cargar();
          } else {
            MensajeError({ message: res.data.error || "No se pudieron importar los códigos" });
          }
        })
        .catch(() => {
          this.setState({ loading: false });
          MensajeError({ message: "Error al conectar con el servidor" });
        });
    };
    reader.readAsArrayBuffer(file.originFileObj || file);
  };

  renderResultado() {
    const { resultado } = this.state;
    if (!resultado) return null;
    return (
      <div style={{ marginBottom: 16 }}>
        <Space size="middle" style={{ marginBottom: 8 }}>
          <Tag color="green">Creados: {resultado.creados}</Tag>
          <Tag color="blue">Actualizados: {resultado.actualizados}</Tag>
          <Tag>Sin cambios: {resultado.sinCambios}</Tag>
          <Tag color={resultado.errores.length ? "red" : "default"}>Con error: {resultado.errores.length}</Tag>
        </Space>
        {resultado.errores.length > 0 && (
          <>
            <Alert type="warning" showIcon style={{ marginBottom: 8 }} message="Estos renglones no se cargaron. Corrígelos en el Excel y vuelve a subirlo." />
            <TableItem
              size="small"
              dataSource={resultado.errores}
              rowKey="fila"
              columns={[
                { title: "Renglón", dataIndex: "fila", key: "fila", width: 90 },
                { title: "Error", dataIndex: "mensaje", key: "mensaje" },
              ]}
            />
          </>
        )}
      </div>
    );
  }

  render() {
    const { permisoConfigurar } = this.props;
    const { editando } = this.state;
    const columns = [
      { title: "Código", dataIndex: "codigo", key: "codigo", width: 110 },
      { title: "Origen", dataIndex: "origen", key: "origen", width: "25%" },
      { title: "Motivo", dataIndex: "motivo", key: "motivo" },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: 110,
        align: "center",
        render: (estado) => (estado === 2 ? <Tag color="red">Inactivo</Tag> : <Tag color="green">Activo</Tag>),
      },
      ...(permisoConfigurar
        ? [
            {
              title: "Acción",
              key: "accion",
              width: 140,
              align: "center",
              render: (_, codigo) => (
                <Space>
                  <Tooltip title="Editar">
                    <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ editando: { ...codigo } })} />
                  </Tooltip>
                  {codigo.estado === 2 ? (
                    <Tooltip title="Activar">
                      <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} onClick={() => this.guardar({ ...codigo, estado: 1 })} />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Desactivar">
                      <ButtonItem type="default" size="small" naranja icon={<StopOutlined />} onClick={() => this.guardar({ ...codigo, estado: 2 })} />
                    </Tooltip>
                  )}
                  <Popconfirm title="¿Eliminar este código?" onConfirm={() => this.eliminar(codigo)}>
                    <Tooltip title="Eliminar">
                      <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} />
                    </Tooltip>
                  </Popconfirm>
                </Space>
              ),
            },
          ]
        : []),
    ];
    const datos = [...this.state.codigos].sort((a, b) => a.origen.localeCompare(b.origen) || a.codigo.localeCompare(b.codigo));

    return (
      <>
        {permisoConfigurar && (
          <Row justify="end" style={{ marginBottom: 16 }}>
            <Col>
              <Space>
                <ButtonItem icon={<DownloadOutlined />} onClick={() => descargarPlantillaCodigos(this.state.codigos)}>
                  Descargar plantilla
                </ButtonItem>
                <Upload showUploadList={false} customRequest={this.onSubirArchivo} accept=".xlsx,.xls">
                  <ButtonItem icon={<UploadOutlined />}>Subir Excel</ButtonItem>
                </Upload>
                <ButtonItem type="primary" icon={<PlusOutlined />} onClick={() => this.setState({ editando: { ...codigoVacio } })}>
                  Agregar código
                </ButtonItem>
              </Space>
            </Col>
          </Row>
        )}
        {this.renderResultado()}
        <TableItem loading={this.state.loading} size="small" dataSource={datos} columns={columns} rowKey="_id" />

        <ModalItem
          title={editando?._id ? "Editar código de tiempo muerto" : "Agregar código de tiempo muerto"}
          visible={!!editando}
          spinning={this.state.loading}
          onCancel={() => this.setState({ editando: null })}
          width="40%"
          paddingTop
        >
          {editando && (
            <>
              <div style={{ marginBottom: 4 }}>Origen</div>
              <InputItem
                placeholder="Ej. MANTENIMIENTO"
                value={editando.origen}
                onChange={(e) => this.setState({ editando: { ...editando, origen: e.target.value } })}
              />
              <div style={{ margin: "12px 0 4px" }}>Motivo</div>
              <InputItem
                placeholder="Ej. FALLA EN EL HORNO"
                value={editando.motivo}
                onChange={(e) => this.setState({ editando: { ...editando, motivo: e.target.value } })}
              />
              <div style={{ margin: "12px 0 4px" }}>Código</div>
              <InputItem
                placeholder="Ej. M05"
                value={editando.codigo}
                onChange={(e) => this.setState({ editando: { ...editando, codigo: e.target.value } })}
              />
              <ButtonItem type="primary" style={{ display: "block", margin: "16px 0 0 auto" }} onClick={() => this.guardar(editando)}>
                Guardar
              </ButtonItem>
            </>
          )}
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(CodigosTiempoMuertoPU);
